import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import photo01 from "../../images/representatives/representatives_01.jpg";
import photo02 from "../../images/representatives/representatives_02.jpg";
import photo03 from "../../images/representatives/representatives_03.jpg";
import photo04 from "../../images/representatives/representatives_04.jpg";
import PageNotFound from "../PageNotFound";

const REPRESENTATIVES_DATA = [
  {
    id: 1,
    name: "pages.advisory_board.representatives_01",
    position: "pages.advisory_board.representatives_01.position",
    photo: photo01,
    text: "pages.advisory_board.representatives_01.text",
  },
  {
    id: 2,
    name: "pages.advisory_board.representatives_02",
    position: "pages.advisory_board.representatives_01.position",
    photo: photo02,
    text: "pages.advisory_board.representatives_02.text",
  },
  {
    id: 3,
    name: "pages.advisory_board.representatives_03",
    position: "pages.advisory_board.representatives_01.position",
    photo: photo03,
    text: "pages.advisory_board.representatives_03.text",
  },
  {
    id: 4,
    name: "pages.advisory_board.representatives_04",
    position: "pages.advisory_board.representatives_01.position",
    photo: photo04,
    text: "pages.advisory_board.representatives_04.text",
  },
];

function AdvisoryBoardRepresentativePage() {
  const { t } = useTranslation();
  const { id } = useParams();

  let currentRepresentative = REPRESENTATIVES_DATA.find((item) => item.id === Number(id));

  if (!currentRepresentative) {
    return <PageNotFound />;
  }

  let title = {
    caption: t(currentRepresentative.name),
  };

  return (
    <MainLayout title={title}>
      <Page title={t(currentRepresentative.name)} titleKey={currentRepresentative.name} intro={t(currentRepresentative.position)} introKey={currentRepresentative.position}>
        <div className="representatives__item">
          <div className="representatives__photo">
            <img src={currentRepresentative.photo} alt={t(currentRepresentative.name)} />
          </div>

          <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: t(currentRepresentative.text) }}></div>
        </div>
      </Page>
    </MainLayout>
  );
}

export default AdvisoryBoardRepresentativePage;
